import { Component, OnInit, NgZone } from "@angular/core";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { WorkoutService, AlertService } from "../../../services";
import {
  WorkoutsState,
  TopBox,
  Fields,
  Store,
  Types,
  AutoUnsubscribe,
  Subscription,
} from "../store";
import { InjuryService } from "../../../services/injury.service ";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

import { AmChart, AmChartsService } from "@amcharts/amcharts3-angular";

@Component({
  selector: "app-team-player-injuries",
  templateUrl: "./team-player-injuries.component.html",
  styleUrls: ["./team-player-injuries.component.css"],
})
@AutoUnsubscribe
export class TeamPlayerInjuriesComponent implements OnInit {
  playerID: number = 0;
  teamID: number = 0;
  public alphaNumericPattern = /^[a-zA-Z ]+$/;

  form: FormGroup;
  formData: any;
  public isShowInjuryForm: boolean = false;
  public isShowInjuryHistory: boolean = false;

  allPlayerInjuries = [];
  public links: { title: string; url: any; }[] = [];

  public profilePicture: string = "";
  public fullName: string = "";
  public totalInjuries = 0;
  public totalDaysInjuredEstimation = 0;
  public totalDaysInjured = 0;
  public currentStatus = 0;

  constructor(
    private _service: InjuryService,
    private store: Store<WorkoutsState>,
    private spinner: Ng4LoadingSpinnerService,
    private _alertService: AlertService,
    private activeRoute: ActivatedRoute,
    public _router: Router,
    private fb: FormBuilder,
    private zone: NgZone,
    private AmCharts: AmChartsService
  ) {

    this.teamID = this.activeRoute.snapshot.params.teamID;
    this.playerID = this.activeRoute.snapshot.params.playerID;

    this.links = [
      { title: 'TEAM PLAYER LIST', url: '/team-injury/team-all-injuries' },
      { title: 'PLAYER', url: null }
    ];
  }

  ngOnInit() {
    this.popupConfirmForm = this.fb.group({
      confirm_discount_delete: [
        null,
        [Validators.required, Validators.pattern(this.alphaNumericPattern)],
      ],
    });
    this.loadAllPlayerInjuriesByPlayersID(this.playerID, this.teamID);
    this.loadChartDataByPlayerID(this.playerID, this.teamID);
  }

  // private chart: am4charts.XYChart;
  loadChartDataByPlayerID(playerID: number, teamID: number) {
    this._service.loadChartDataByPlayerID(playerID, teamID).subscribe(
      (result: any) => {
        // this.spinner.hide();
        console.log("CHART DATA ==> ", result);
        this.chartData = result;
        this.generateReportGraph();
      },
      (error) => {
        // this.spinner.hide();
      }
    );
  }
  private chartData: any;
  private chart: AmChart;
  generateReportGraph() {
    this.chart = this.AmCharts.makeChart("chartdiv", {
      type: "serial",
      dataProvider: this.chartData,
      startDuration: 1,
      graphs: [
        {
          fillColors: "#6CBCEB",
          balloonText: "[[category]]: <b>[[value]]</b>",
          fillAlphas: 0.8,
          lineAlpha: 0.2,
          type: "column",
          valueField: "injuries",
        },
      ],
      chartCursor: {
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        zoomable: false,
      },
      categoryField: "month",
    });
  }




  loadAllPlayerInjuriesByPlayersID(playerID: number, teamID: number) {
    this.spinner.show();
    this._service.loadAllPlayerInjuriesByPlayersID(playerID, teamID).subscribe(
      (result: any) => {
        this.allPlayerInjuries = result.injuries;
        this.profilePicture = result.profilePicture;
        this.fullName = result.fullName;
        this.totalDaysInjured = result.totalDaysInjured;
        this.totalDaysInjuredEstimation = result.totalDaysInjuredEstimated;
        this.totalInjuries = result.totalInjuries;
        this.currentStatus = result.currentStatus;
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        console.log("Could not load all injuries");
      }
    );
  }


  public selectedInjuryHistory = null;

  onShowPlayerInjuryHistory(x) {

    this.selectedInjuryHistory = x;
    const injuryID = x.injuryID;

    this.spinner.show();
    this._service.loadInjuryHistory(injuryID).subscribe((result: any) => {
      this.spinner.hide();
      this.selectedInjuryHistory = result;
      this.isShowInjuryHistory = true;

      //console.log("selectedInjuryHistory History Data ===> ", result);
      //console.log("selectedInjuryHistory History Data ===> ", result);
    }, error => {
      this.spinner.hide();
      this._alertService.error("Could not load injury history data");
    })
  }

  showAddInjuryForm() {
    this.spinner.show();
    this._service.loadInjuryInformations().subscribe(
      (result) => {
        this.formData = result;
        console.log("Form Data ==> ", this.formData);
        this.isShowInjuryForm = true;
        this.isShowInjuryHistory = false;
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  notifyUserSuccess(event) {
    this.isShowInjuryForm = false;
    this.isShowInjuryHistory = false;
    this._alertService.success("New injury record added to player");
    this.loadAllPlayerInjuriesByPlayersID(this.playerID, this.teamID);
    this.loadChartDataByPlayerID(this.playerID, this.teamID);
  }

  showInjuryDetails(injuryID) {
    console.log("showInjuryDetails  ==>  ", injuryID)
    this._router.navigate(["/team-injury/team-player-injuries/" + this.teamID + "/" + this.playerID + "/" + injuryID]);
  }

  onDeleteSelectedInjuries() {
    // const injuryIDs = this.selectedPlayerInjuries.map(a => a.injuryID);
    this.openPopup();
  }

  // deleteSelectedDiscountRecords(events) {
  //   this.openPopup();
  // }
  public isOpenConfirmDeletePopup = false;
  public popupConfirmForm: FormGroup;

  openPopup() {
    this.isOpenConfirmDeletePopup = true;
  }
  closePopup() {
    this.removeValidation("confirm_discount_delete");
    this.isOpenConfirmDeletePopup = false;
  }

  onPopUpConfirm(formValue) {
    const flag = this.isDeleteTextMatched();
    if (flag) {
      this.closePopup();
      this.deleteSelectedInjuries();
    }
  }
  removeValidation(name) {
    const control = this.popupConfirmForm.get(name);
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }
  isDeleteTextMatched() {
    const val = this.popupConfirmForm.get("confirm_discount_delete").value;
    if (val) {
      return val.trim() === "DELETE" ? true : false;
    }
  }
  isConfirmDeleteValid() {
    return (
      this.popupConfirmForm.get("confirm_discount_delete").errors &&
      (this.popupConfirmForm.get("confirm_discount_delete").touched ||
        this.popupConfirmForm.get("confirm_discount_delete").dirty)
    );
  }

  deleteSelectedInjuries() {
    const injuryIDs = this.selectedPlayerInjuries
      .map((a) => a.injuryID)
      .join(",");

    console.log("Selected Injuries Payload ==> ", injuryIDs);

    this.spinner.show();
    this._service.removePlayerInjuries(injuryIDs).subscribe(
      (data: any) => {
        // this.selectedPlayerInjuries.length = 0;
        this.allPlayerInjuries.forEach((x) => (x.checked = false));
        this.removeValidation("confirm_discount_delete");
        this.closePopup();
        this.spinner.hide();
        this._alertService.success("Injury list updated");
        this.loadAllPlayerInjuriesByPlayersID(this.playerID, this.teamID);
        this.loadChartDataByPlayerID(this.playerID, this.teamID);
      },
      (error) => {
        console.log(error);
        this._alertService.error("Could not remove selected injuries");
      }
    );
  }

  get allChecked() {
    return (
      this.allPlayerInjuries &&
      this.allPlayerInjuries.length &&
      this.allPlayerInjuries.every((p) => p.checked)
    );
  }

  set allChecked(checked: boolean) {
    this.allPlayerInjuries.forEach((x) => (x.checked = checked));
  }

  get selectedPlayerInjuries() {
    return this.allPlayerInjuries.filter((x) => x.checked);
  }

  closeOverlay(event) {
    this.isShowInjuryForm = false;
    this.isShowInjuryHistory = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/team-injuries/team-player-injuries/team-player-injuries.component.ts